// base_view_mode_switch 1 
import { useEffect, useState } from "react"
import ButtonGroup from "./button_group"
import { Button } from './ot'
import { LayoutGrid, List } from "lucide-react"
const BaseViewModeSwitch1 = ({
    button_data = [
        {
            label: "卡片模式",
            icon: <LayoutGrid className="h-4 w-4" />,
            key: "卡片模式"
        },
        {
            label: "列表模式",
            icon: <List className="h-4 w-4" />,
            key: "列表模式"
        }
    ],
    defaultActiveKey = null,
    onChange = () => { }
}) => {
    const [activeKey, setActiveKey] = useState(defaultActiveKey)
    useEffect(() => {
        setActiveKey(defaultActiveKey)
    }, [defaultActiveKey])


    return (<ButtonGroup
        direction="row"
        gap="8px"
        align="end"
        wrap={true}
        visible={true}
    >
        {
            button_data.map((val) => {
                return (<Button
                    size="small"
                    onClick={() => {
                        setActiveKey(val?.key)
                        onChange(val?.key)
                    }}
                    type={"default"}
                    className={val?.key === activeKey ? "bg-muted" : ""}
                >
                    {val?.icon}{val?.label}
                </Button>)
            })
        }
    </ButtonGroup>)
}
export default BaseViewModeSwitch1
